import React, { useEffect, useState } from 'react'
import { workflowService } from '../../../../services/admin/workflow'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { Box, Divider, IconButton, Tooltip, Typography } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router-dom'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'

const ActivityList = ({ process }) => {
  const { admincardtitle } = useResponsiveTypography()

  const { user } = useAuthContext()
  const navigate = useNavigate()
  const [activities, setActivities] = useState([])

  useEffect(() => {
    ;(async () => {
      const list = await workflowService.getActivities(user, process.id)
      setActivities(list)
    })()
  }, [process.id])

  return (
    <Box style={{ width: '100%' }}>
      {activities.length > 0 && <Divider style={{ margin: '8px 0px 8px 0px' }} />}
      {activities
        .sort((a, b) => a.rank - b.rank)
        .map((it, index) => {
          return (
            <Box key={it.id} style={{ padding: '4px 10px', width: '100%', background: 'white' }}>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <Tooltip title={it.description}>
                    <Typography
                      className="textSecondary fontWeight600"
                      style={{ fontSize: admincardtitle }}
                    >
                      {it.id}.
                      <strong className="textprimaryblue"> {it.activity_template_name} </strong> (
                      {it.activity_type})
                    </Typography>
                  </Tooltip>
                </Box>
                <Box style={{ display: 'flex', columnGap: 8 }}>
                  <Tooltip title="Activity Config">
                    <IconButton
                      onClick={() => navigate('/admin/activity-config/' + it.id)}
                      style={{ backgroundColor: '#f6f4f9', height: 32, width: 32 }}
                      size="small"
                    >
                      <SettingsOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="User Assignment">
                    <IconButton
                      onClick={() => navigate('/admin/user-assignments/' + it.id)}
                      style={{ backgroundColor: '#f6f4f9', height: 32, width: 32 }}
                      size="small"
                    >
                      <GroupsOutlinedIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>

                  {/* <Tooltip title="Delete Activity">
                  <IconButton
                    // onClick={() => setForDeletion(it)}
                    style={{ backgroundColor: '#f2eeed', height: 32, width: 32 }}
                    size="small"
                  >
                    <DeleteIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Tooltip> */}
                </Box>
              </Box>
              {index + 1 != activities.length && <Divider style={{ marginTop: 8 }} />}
            </Box>
          )
        })}
    </Box>
  )
}

export default ActivityList
